import { atom } from 'recoil';
import { TStateMap } from '@metadata';

const mapState = atom<TStateMap>({
  key: 'mapState',
  default: {
    metadata: {
      instance: null,
    },
    status: {
      mapType: 'base',
      loadStart: false,
      wkt: null,
      obj_id: null,
    },
  },
});

export default mapState;
